import { Component, OnInit,ErrorHandler } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';
import { NgForm} from '@angular/forms';

@Component({
  selector: 'app-scheme-creation-form',
  templateUrl: './scheme-creation-form.component.html',
  styleUrls: ['./scheme-creation-form.component.css']
})
export class SchemeCreationFormComponent implements OnInit {
  [x: string]: any;

title="Scheme Creation";


AcountTypelist : any = [];
LedgerNamesList : any = [];
branchList : any = [];
agentList : any = [];
subLedgerList : any = [];
data : any = {}
r : any = {};
v : any = {};
a : any = {};
branchid:any;
monthlybased:boolean;
dailtbased:boolean;
donesubmitting:boolean;

Configurations : any = [];
  constructor(private userService: UserService,private router: Router, private route: ActivatedRoute,private errorHandler: ErrorHandler,
    private datepipe: DatePipe ) { 
    
      //userName
      console.log('UserName')      ;
      console.log(localStorage.getItem('userName'))
      
    }

  ngOnInit()
  {
   this.Configurations=[]; 
    this.branchid=localStorage.getItem('BRANCH_ID');
    this.route.params.subscribe(params => {
      debugger;
      this.mode = params['mode'];
      this.GlSUB_ID = params['GlSUB_ID'];
    });
    if (this.GlSUB_ID != null && this.mode != null)
    {
      this.GetSchemeDetailsById(this.GlSUB_ID);
      this.title= this.mode+this.title;
    }
    
    this.getbranchlist()
    this.getAccountType();
    this.monthlybased=false;
    this.dailtbased=false;
  }

  getbranchlist()
  {
  this.data = this.userService.GetAllBranchesforsc();
    this.data.subscribe(
       (response: any) => {         
        this.branchList= response;   
        
       }) 
  }

  getAccountType(){
    this.data = this.userService.GetAccountTypeforschemecreation();
    this.data.subscribe(
       (response: any) => {         
        this.AcountTypelist= response;  
        console.log(this.AcountTypelist)
   })
  }


  ChangeLCode(GL_CODEE){
    if(GL_CODEE >=0){
    this.data = this.userService.GetSubLedger(GL_CODEE);
    this.data.subscribe(
       (response: any) => {         
        this.subLedgerList= response;   
       }) 
      }          
   }

   ChangeModId(ACC_TYPEE){
    if(ACC_TYPEE >=0){ 
     this.data = this.userService.GetAllLedgerNameforsc(ACC_TYPEE);
     this.data.subscribe(
        (response: any) => {         
         this.LedgerNamesList= response;   
        })
    } 
    
    this.data = this.userService.GetAllBranchesforsc();
    this.data.subscribe(
       (response: any) => {         
        this.branchList= response;   
        
       }) 
  }

  

  AddConfiguration(v) 
  {
    debugger;
    if(v.PERIOD_M_FR==undefined||null || v.PERIOD_M_TO==undefined||null || v.PEN_RATE==undefined||null || 
      v.INT_RATE==undefined||null || v.INTPENALTY==undefined||null || v.Charges==undefined||null)
    {
        swal('Required','Please Fill all the mandatory fiedls','warning');
    }
    else
    {
      if(this.Configurations.length!=0)
      {
        let rulechecklength=this.Configurations.length-1;
        let rulelength=this.Configurations.length;
        for(let i=rulechecklength;i<rulelength;i++)
        {
        if(this.monthlybased==true)
        {
          if(this.Configurations[i].PERIOD_M_FR==v.PERIOD_M_FR)
            swal("Rules","FROM MONTH cannot be same, it is already defined in earlier rules ",'warning');
          else if(this.Configurations[i].PERIOD_M_TO==v.PERIOD_M_TO)
            swal("Rules","TO MONTH cannot be same, it is already defined in earlier rules ",'warning');
          else if(v.PERIOD_M_FR<this.Configurations[i].PERIOD_M_TO)
            swal("Rules","FROM MONTH should not be less  than TO MONTH of the earlier rule","warning");
          // else if(v.PERIOD_M_TO<v.PERIOD_M_FR)
          //   swal("Rules","TO MONTH cannot be less than FROM MONTH","warning");
          else if(v.PEN_RATE>0 && v.INT_RATE>0)
          {
              swal("Rules","Both Commission rate and Intrest rate cannot be persent",'warning');
          }
          else if(v.PERIOD_M_FR==v.PERIOD_M_TO)
              swal("Rules","FROM MONTH and TO MONTH caanot be same","info")
          else if(i==rulelength-1)
          {
            this.addconfig(v);
            swal("Rules","Added","success");
          }
        }
        else if(this.dailtbased==true)
        {
          if(this.Configurations[i].PERIOD_D_FR==v.PERIOD_D_FR)
            swal("Rules","FROM DAY cannot be same, it is already defined in earlier rules ",'warning');
          else if(this.Configurations[i].PERIOD_D_TO==v.PERIOD_D_TO)
           swal("Rules","TO DAY cannot be same, it is already defined in earlier rules ",'warning');
           else if(v.PERIOD_D_FR<this.Configurations[i].PERIOD_D_TO)
            swal("Rules","FROM DAY should not be less  than TO DAY of the earlier rule","warning");
          // else if(v.PERIOD_D_TO<v.PERIOD_D_FR)
          //   swal("Rules","TO DAY cannot be less than FROM DAY","warning");
          else if(v.PEN_RATE>0 && v.INT_RATE>0)
          {
              swal("Rules","Both Commission rate and Intrest rate cannot be persent",'warning');
          }
          else if(i==rulelength-1)
          {
            this.addconfig(v);
            swal("Rules","Rule Added","success");
          }
        }
       }

      }
      else if(this.monthlybased==true)  //for i=0
      {
        if(v.PERIOD_M_FR>0)
          swal("Rules","FROM MONTH should start from initial 0","warning")
        else if(v.PERIOD_M_TO<v.PERIOD_M_FR)
          swal("Rules","TO DAY cannot be less than FROM DAY","warning");
        else if(v.PERIOD_M_FR==v.PERIOD_M_TO)
          swal("Rules","FROM MONTH and TO MONTH caanot be same","warning")
        else if(v.PEN_RATE>0 && v.INT_RATE>0)
            swal("Rules","Both Commission rate and Intrest rate cannot be persent",'warning');
        else
          {
            this.addconfig(v);
            swal("Rules","Added","success");
          }
      }
      else if(this.dailtbased==true)
      {
        if(v.PERIOD_D_FR>0)
        swal("Rules","FROM MONTH should start from initial 0","warning")
      else if(v.PERIOD_D_TO<v.PERIOD_D_FR)
        swal("Rules","TO DAY cannot be less than FROM DAY","warning");
      else if(v.PERIOD_D_FR==v.PERIOD_D_TO)
        swal("Rules","FROM MONTH and TO MONTH caanot be same","warning")
      else if(v.PEN_RATE>0 && v.INT_RATE>0)
          swal("Rules","Both Commission rate and Intrest rate cannot be persent",'warning');
      else
        {
          this.addconfig(v);
          swal("Rules","Added","success");
        }
      }
    }
  }

  addconfig(v)
  {
    debugger;
    let temp = {
      PERIOD_M_FR: v.PERIOD_M_FR,
      PERIOD_M_TO  :  v.PERIOD_M_TO,
      PERIOD_D_FR : v.PERIOD_D_FR,
      PERIOD_D_TO :  v.PERIOD_D_TO,
      PEN_RATE : v.PEN_RATE,
      INT_RATE:  v.INT_RATE,  
      INTPENALTY:  v.INTPENALTY,
      Charges:   v.Charges
    }
    this.Configurations.push(temp);
    this.v = {};
    if(this.r.PERIOD_M_DISP==v.PERIOD_M_TO || this.r.PERIOD_M_DISP==v.PERIOD_D_TO )
    {
        this.v.PERIOD_M_FR=v.PERIOD_M_TO;
        this.v.PERIOD_M_TO=99;
    }
    debugger;
    console.log(temp);
  }
    

  //   ClearNominee()
  //   {
  //   this.n = {};
  // }
      

       //remove row
       RemoveConfigurations(i){    
    swal({
      title: 'Are you sure?', text: "You want to Remove!", type: 'warning',
       showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
       
        if (result.value) 
        {
          this.Configurations.splice(i, 1);      
        }
        else
        {

        } 
  })
    
    
  }
  SUB_DESCfiled()
  {
    debugger;
    this.SUB_DESempty=false;
  }
  Periodfilled()
  {
    this.Periodempty=false;
  }
  EFFECTIVE_DTfilled()
  {
    this.EFFECTIVE_DTempty=false;
  }


  wrong:string="";
  SUB_DESempty:boolean=false;
  Periodempty:boolean=false;
  EFFECTIVE_DTempty:boolean=false;


  Savescheme(scheme_creation: NgForm) {
    debugger;
    
  if
  (scheme_creation.value.PERIOD_M_DISP==undefined || scheme_creation.value.EFFECTIVE_DT==undefined||null || scheme_creation.value.SUB_DESC==undefined||null
  )
  {
    if(scheme_creation.value.PERIOD_M_DISP==undefined)
        this.Periodempty=true;
    //this.wrong="custom-field mandatory";
    if(scheme_creation.value.SUB_DESC==undefined||null)
      this.SUB_DESempty=true;
    if(scheme_creation.value.EFFECTIVE_DT==undefined||null)
      this.EFFECTIVE_DTempty=true;
      debugger;
    swal("Warning!", "Please enter all the Mandatory fields",'warning');
  } 
  else if(this.Configurations==undefined||null )
  {
    swal("Warning!", "Scheme Rules are not defined",'warning');
  }
  else
  {
      if(scheme_creation.value.AGREED_AMT==null||undefined)
      scheme_creation.value.AGREED_AMT=0;   //1
      if(scheme_creation.value.MIN_AMT_REQ==null||undefined)
      scheme_creation.value.MIN_AMT_REQ=0;
      
      // if(scheme_creation.value.INTPENALTY==null||undefined)
      // scheme_creation.value.INTPENALTY=0;

      scheme_creation.value.schemeconfig=this.Configurations;     
    this.data = this.userService.PostSchemeCreation(scheme_creation.value);
    this.data.subscribe(
      (response) => {
        scheme_creation.reset();
        scheme_creation.resetForm();
        scheme_creation.form.markAsPristine();
        scheme_creation.form.markAsUntouched();
        swal('Success!', 'Scheme  Added Successfully,', 'success');
        this.router.navigate(['/home/UnicoreMaster2/scheme-creation']);
        // document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        // document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
           swal('Warning!', error.error.Message, 'warning');
        }
        else
        {
          swal('Error! Something went wrong','Error: '+error,'error');
        }
      });

  //  }
    }
      
  }
  GetSchemeDetailsById(GlSUB_ID)
  {

    debugger;
    this.schdata=this.userService.GetSchemeById(GlSUB_ID,this.branchid);
    this.schdata.subscribe(
      (response:any)=>
      {
        let sch=response.schemeconfig;
        debugger;
        console.log(response);
        this.r=response;
        this.ChangeModId(response.ACC_TYPE); 
        
        this.r.SUB_DESC=response.GLSUB_DESC;
        this.Configurations=response.schemeconfig;
        console.log(response.schemeconfig[0].EFFECTIVE_DT);
        this.r.EFFECTIVE_DT=response.schemeconfig[0].EFFECTIVE_DT;//this.getdatefun(response.schemeconfig[0].EFFECTIVE_DT);
        this.r.MIN_AMT_REQ=response.schemeconfig[0].MIN_AMT_REQ;
        this.r.BRANCH_ID=response.BRANCH_ID;
        this.r.GL_CODE=response.GL_CODE;
        this.r.AGREED_AMT=response.schemeconfig[0].AGREED_AMT;
        this.r.PERIOD_M_DISP= this.Configurations[0].PERIOD_M_DISP!=null||0? this.Configurations[0].PERIOD_M_DISP: this.Configurations[0].PERIOD_D_DISP;
        this.r.GLSUB_ID=response.GLSUB_ID;
        if( this.Configurations[0].PERIOD_M_TO)
        {
          this.monthlybased=true;
          this.dailtbased=false;
          
        }
        else if( this.Configurations[0].PERIOD_D_DISP)
        {
          this.monthlybased=false;
          this.dailtbased=true;
        }
        else
        {
          this.monthlybased=false;
          this.dailtbased=true;
        }
      } 
    )

  }
  
  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }

  Updatescheme(scheme_creation: NgForm) 
  {
    debugger;
    scheme_creation.value.schemeconfig=this.Configurations;
    this.updata=this.userService.updatescheme(scheme_creation.value);
    this.updata.subscribe(
      (resp:any)=>
      {
         swal('Updated','Scheme updated successfull','success');
      }
    )
  }
  editconfig(adat)
  {
    debugger;
    this.v.PERIOD_M_FR=adat.PERIOD_M_FR;
    this.v.PERIOD_M_TO=adat.PERIOD_M_TO,
    this.v.PERIOD_D_FR=adat.PERIOD_D_FR,
    this.v.PERIOD_D_TO=adat.PERIOD_D_TO,
    this.v.PEN_RATE=adat.PEN_RATE,
    this.v.INT_RATE=adat.INT_RATE,
    this.v.INTPENALTY=adat.INTPENALTY,
    this.v.Charges=adat.Charges,
    this.v.SLNO=adat.SLNO
  }
  updateconfig(v)
  {
    for(let i=0;i<=this.Configurations.length;i++)
    {
      if(v.SLNO==this.Configurations[i].SLNO)
      {
        debugger;
        this.Configurations[i].PERIOD_M_FR=v.PERIOD_M_FR==undefined||null?0:v.PERIOD_M_FR,
        this.Configurations[i].PERIOD_M_TO=v.PERIOD_M_TO==undefined||null?0:v.PERIOD_M_TO,
        this.Configurations[i].PERIOD_D_FR=v.PERIOD_D_FR==undefined||null?0:v.PERIOD_D_FR,
        this.Configurations[i].PERIOD_D_TO=v.PERIOD_D_TO==undefined||null?0:v.PERIOD_D_TO,
        this.Configurations[i].PEN_RATE=v.PEN_RATE,
        this.Configurations[i].INT_RATE=v.INT_RATE,
        this.Configurations[i].INTPENALTY=v.INTPENALTY,
        this.Configurations[i].Charges=v.Charges,
        this.Configurations[i].SLNO=v.SLNO
      }
    }

  }

  clearconfig()
  {
    this.v={};
  }

  daymonth()
  {
   this.monthlybased=false;
   this.dailtbased=true;
  }
  monthday()
  {
    this.monthlybased=true;
    this.dailtbased=false;
  }
  checkdate()
  {
    if(this.r.EFFECTIVE_DT.length>10)
     {
       swal('Date','Date not Correct','warning');
       this.r.EFFECTIVE_DT='';
     }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/unicore-masters/Scheme-Creation/scheme-creation-form/scheme-creation-form.component.ts